import { key, notify } from '@databases/ping-registry';
import { createEffect } from '@databases/selections';
import { type SelectionsApi } from '@databases/selections-api';

interface CellPosition {
  row: { index: number };
  col: { index: number };
}

export const createCellEditingEffect = createEffect(
  ({ selectionsApiFactory }: { selectionsApiFactory: () => SelectionsApi }) => {
    let isOpen = false;
    let openPosition: CellPosition | undefined;

    const getCellIds = (position: CellPosition) => {
      const selectionsApi = selectionsApiFactory();
      return selectionsApi.resolvePositionToIds(position, 'cell');
    };

    const setCellEditingState = (position: CellPosition, editing: boolean) => {
      const { entryId, fieldId } = getCellIds(position);
      if (entryId && fieldId) {
        const cellKey = key('cell', { entryId, fieldId });
        notify(cellKey, 'editing', editing);
      }
    };

    return {
      dispose() {
        if (isOpen && openPosition) {
          setCellEditingState(openPosition, false);
        }
        isOpen = false;
        openPosition = undefined;
      },

      deltaTypes: ['cellEditRequested'],

      onDelta(delta) {
        const isSameCell =
          openPosition &&
          openPosition.row.index === delta.position.row.index &&
          openPosition.col.index === delta.position.col.index;

        if (isOpen && isSameCell) {
          isOpen = false;
          openPosition = undefined;
          return;
        }

        const { entryId, fieldId } = getCellIds(delta.position);

        if (!fieldId || !entryId) {
          return;
        }

        setCellEditingState(delta.position, true);
        isOpen = true;
        openPosition = delta.position;
      },
    };
  }
);
